













































































import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';
import { SimType } from '@/data/mobile/simType';

import Heading3 from '@/components/Atoms/Heading/Heading3.vue';

import TotalLineCount from '@/components/Molecules/Text/TotalLineCount.vue';

import Plan from '@/components/Pages/MobileEstimate/Plan.vue';
import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import OptionComponent from '@/components/Pages/MobileEstimate/Option.vue';
import ModalTextLink from '@/components/Atoms/Link/ModalTextLink.vue';
import BasicModal from '@/components/Molecules/Modal/BasicModal.vue';
import TextLink from '@/components/Atoms/Link/TextLink.vue';
import UrlMixin from '@/mixins/url';

@Component({
  components: {
    UnorderedList,
    OptionComponent,
    Plan,
    TotalLineCount,
    Heading3,
    ModalTextLink,
    TextLink,
    BasicModal,
  },
})
export default class SimTypeComponent extends mixins(UrlMixin) {
  @Prop() private simType!: SimType;
  @Prop() private mobileConfig!: any;
  @Prop() private detailShow!: { [key: string]: boolean };
  private namespace: string = 'mobile';

  public planCountBySimType(simType: string) {
    return this.$store.getters[`${this.namespace}/count`]({
      stateKey: 'plans',
      simType: simType,
    });
  }

  planCount(carrier: string, simType: string) {
    return this.$store.getters[`${this.namespace}/count`]({
      stateKey: 'plans',
      carrier: carrier,
      simType: simType,
    });
  }

  planCountList(simType: string) {
    return [this.planCount('docomo', simType), this.planCount('au', simType)];
  }

  get planTotal(): number {
    return this.$store.getters[`${this.namespace}/count`]({
      stateKey: 'plans',
    });
  }

  changeDetailShow(simTypeId: string) {
    if (this.detailShow[simTypeId]) {
      this.$delete(this.detailShow, simTypeId);
    } else {
      this.$set(this.detailShow, simTypeId, !this.detailShow[simTypeId]);
    }
  }
}
